import React, { useEffect, useState } from "react";
import { Input } from "@/components/ui/input";
import { Ban } from "lucide-react";
import { fmtDay, endDate, jsDay } from "@/lib/vigilanza";

export function ShiftRow({ date, slot, shift, people, eligible, exclusion, onSave }) {
  const [note, setNote] = useState(shift?.note || "");
  useEffect(() => { setNote(shift?.note || ""); }, [shift?.note]);
  const pid = shift?.person_id || "";
  const options = pid && !eligible.find((p) => p.id === pid) ? [...eligible, ...people.filter((p) => p.id === pid)] : eligible;
  const weekend = [0, 6].includes(jsDay(date));

  return (
    <div className={`grid grid-cols-[110px_1fr] sm:grid-cols-[150px_1fr_1fr] gap-3 items-center px-4 py-2.5 ${exclusion ? "bg-stone-50" : ""}`} data-testid={`vig-row-${date}`}>
      <div className="leading-tight">
        <div className={`font-semibold text-sm ${weekend ? "text-[#E2725B]" : "text-stone-800"}`}>{fmtDay(date)}</div>
        {slot && <div className="text-[11px] font-mono text-stone-500">{slot.start_time} → {endDate(date, slot) !== date ? `${fmtDay(endDate(date, slot))} ` : ""}{slot.end_time}</div>}
      </div>
      {exclusion ? (
        <div className="sm:col-span-2 text-sm text-stone-500 flex items-center gap-2" data-testid={`vig-excluded-${date}`}>
          <Ban size={13}/> Escluso dalla turnazione{exclusion.note ? ` · ${exclusion.note}` : ""}
        </div>
      ) : (
        <>
          <select value={pid} onChange={(e) => onSave({ person_id: e.target.value || null, note })} data-testid={`vig-person-${date}`}
            className="h-9 rounded-md border border-stone-200 bg-white px-2 text-sm min-w-0">
            <option value="">— Nessuno —</option>
            {options.map((p) => <option key={p.id} value={p.id}>{p.name}</option>)}
          </select>
          <Input value={note} onChange={(e) => setNote(e.target.value)} placeholder="Nota (facoltativa)" data-testid={`vig-note-${date}`}
            onBlur={() => note !== (shift?.note || "") && onSave({ person_id: pid || null, note })}
            className="h-9 col-span-2 sm:col-span-1"/>
        </>
      )}
    </div>
  );
}
